<template>
  <div class="get-params modal-content">
    <div class="box">
      <header class="title is-5">Input Params for {{ name }}</header>
      <form class="get-params__form" @submit.prevent="updateMetaHandler">
        <b-field
          v-for="paramName in paramsList"
          :key="paramName"
          :label="'Enter ' + paramName"
        >
          <b-input
            v-model="params[paramName]"
            :placeholder="'Type in ' + paramName"
          ></b-input>
        </b-field>
        <b-button class="is-fullwidth" native-type="submit" type="is-primary"
          >Continue</b-button
        >
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      params: {}
    };
  },
  props: {
    paramsList: {
      type: Array,
      required: true
    },
    name: {
      type: String
    }
  },
  methods: {
    async updateMetaHandler() {
      this.$emit('input', {
        ...this.params
      });
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins.sass';

.get-params {
  width: auto;

  &__form {
    @include tablet {
      min-width: 20rem;
    }
  }
}
</style>
